import api from "../../api/axios";

export const getAssinatura = async () => {
  const response = await api.get("/entrega/assinatura");
  return response.data.assinatura;
};

export const saveAssinatura = async (dataUrl: string) => {
  if (dataUrl === "") {
    return api.delete("/entrega/assinatura");
  }
  return api.post("/entrega/assinatura", { data: dataUrl });
};